import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var Grade = /*#__PURE__*/function (_Entity) {
  _inherits(Grade, _Entity);

  var _super = _createSuper(Grade);

  function Grade() {
    _classCallCheck(this, Grade);

    return _super.apply(this, arguments);
  }

  _createClass(Grade, [{
    key: "key",
    get: function get() {
      return this.props.key;
    }
  }, {
    key: "translation",
    get: function get() {
      return this.props.translation;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return {
        id: this.props.id.toString(),
        key: this.key,
        translation: this.translation
      };
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.key,
        argumentName: 'Key'
      }, {
        argument: props.translation,
        argumentName: 'Translation'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Error');
      }

      return Result.ok(new Grade(props, new UniqueEntityID(props.id)));
    }
  }]);

  return Grade;
}(Entity);